(() => {
  if (customElements.get('dio-carousel-init')) return;
  let sequence = 0;
  customElements.define('dio-carousel-init', class extends HTMLElement {
    async connectedCallback() {
      const generation = this.generation = (this.generation || 0) + 1;
      try {
        await window.DioAssets.domReady;
        const kind = this.dataset.kind;
        const media = this.dataset.media ? window.matchMedia(this.dataset.media) : null;
        if (kind !== 'instructions') await window.DioAssets.dependency('jquery');
        if (kind !== 'instructions' && (!media || media.matches)) await window.DioAssets.load(this.dataset.library, {dependencies:['jquery'], library:kind === 'owl' ? 'owlCarousel' : 'slick'});
        if (kind === 'owl' || this.dataset.dots) await window.DioAssets.dependency('phase-two');
        if (!this.isConnected || this.generation !== generation) return;
        const $ = window.jQuery;
        const scope = this.closest('[id^="shopify-section-"]') || this.parentElement;
        const namespace = '.dioSection' + (++sequence);
        const options = JSON.parse(this.dataset.options || '{}');
        const targets = Array.from(scope.querySelectorAll(this.dataset.selector));
        const cleanups = [];
        this.savedStates = this.savedStates || new WeakMap();
        if (kind === 'instructions') {
          targets.forEach(button => {
            const panel = button.nextElementSibling;
            if (!panel) return;
            const toggle = () => {
              const expanded = button.getAttribute('aria-expanded') === 'true';
              button.setAttribute('aria-expanded', String(!expanded));
              if (window.jQuery) window.jQuery(panel).stop(true, true).slideToggle(300);
              else panel.style.display = expanded ? 'none' : 'block';
            };
            button.addEventListener('click', toggle);
            cleanups.push(() => {
              button.removeEventListener('click', toggle);
              if (window.jQuery) window.jQuery(panel).stop(true, true);
            });
          });
        } else {
          const mounted = new Map();
          let frame = null;
          let preparing = false;
          let cancelled = false;
          // Resolve window breakpoints before Slick builds its first slide tree.
          // Other respondTo modes keep Slick's native responsive handling.
          const managedResponsive = kind === 'slick' && Array.isArray(options.responsive) && (!options.respondTo || options.respondTo === 'window');
          const breakpoints = managedResponsive ? new Map(options.responsive.map(rule => [Number(rule.breakpoint), rule.settings])) : null;
          const responsiveState = () => {
            if (!managedResponsive) return {key:null, options};
            const width = window.innerWidth;
            const candidates = [...breakpoints.keys()].sort((a, b) => options.mobileFirst ? a - b : b - a);
            let key = null;
            candidates.forEach(point => { if (options.mobileFirst ? width > point : width < point) key = point; });
            const settings = key === null ? null : breakpoints.get(key);
            return {key, options:settings === 'unslick' ? null : {...options, ...settings, responsive:null}};
          };
          const presented = (target, displays) => {
            if (media && !media.matches || target.closest('[hidden]') || target.style.display === 'none') return false;
            const disclosure = target.previousElementSibling;
            if (disclosure?.matches('button.accordion') && disclosure.getAttribute('aria-expanded') !== 'true') return false;
            for (let owner = target.parentElement; owner; owner = owner.parentElement) {
              if (!displays.has(owner)) displays.set(owner, getComputedStyle(owner).display);
              if (displays.get(owner) === 'none') return false;
              if (owner === scope) break;
            }
            return true;
          };
          const mount = (target, effectiveOptions) => {
            const targetCleanups = [];
            if (kind === 'owl') {
            const $target = $(target);
            if ($target.data('owl.carousel')) return;
            const saved = this.savedStates.get(target);
            $target.owlCarousel({...options, ...(saved ? {startPosition:saved.slide} : {})});
            const dotCleanup = window.DioPhaseTwo.refreshInstructionCarousels(target, true);
            if (dotCleanup) targetCleanups.push(dotCleanup);
            targetCleanups.push(() => {
              const carousel = $target.data('owl.carousel');
              if (carousel) { this.savedStates.set(target, {slide:carousel.relative(carousel.current())}); $target.owlCarousel('destroy'); }
            });

            } else {
            const $slider = $(target);
            if ($slider.hasClass('slick-initialized')) return;
            const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
            const saved = this.savedStates.get(target);
            const count = effectiveOptions.slide ? $slider.children(effectiveOptions.slide).length : target.children.length;
            const lastSlide = Math.max(0, count - (effectiveOptions.slidesToShow || 1));
            const initialSlide = saved ? (effectiveOptions.infinite !== false ? saved.slide : Math.min(saved.slide, lastSlide)) : effectiveOptions.initialSlide;
            $slider.slick({...effectiveOptions, ...(initialSlide == null ? {} : {initialSlide}), autoplay:!!effectiveOptions.autoplay && !motion.matches && !(saved && saved.paused)});
            const $dots = this.dataset.dots ? $(scope.querySelector(this.dataset.dots)) : $();
            let motionCleanup;
            if ($dots.length) {
              const count = parseInt($dots.attr(this.dataset.countAttribute) || '0', 10);
              $dots.empty();
              for (let index = 0; index < count; index++) {
                const $li = $('<li></li>');
                const $button = $('<button type="button"></button>').attr('aria-label', this.dataset.dotLabel.replace('__number__', String(index + 1)).replace('__total__', String(count)));
                $li.append($button);
                if (index === $slider.slick('slickCurrentSlide')) $li.addClass('is-active').find('button').attr('aria-current', 'true');
                $dots.append($li);
              }
              $dots.find('button').on('click' + namespace, function () { $slider.slick('slickGoTo', $(this).parent().index()); });
              const updateDot = index => {
                $dots.find('li').removeClass('is-active').find('button').removeAttr('aria-current');
                $dots.find('li').eq(index).addClass('is-active').find('button').attr('aria-current', 'true');
              };
              // Reflect the incoming slide immediately, then reconcile at rest.
              $slider.on('beforeChange' + namespace, (event, slick, current, next) => updateDot(next));
              $slider.on('afterChange' + namespace, (event, slick, index) => updateDot(index));
              motionCleanup = window.DioPhaseTwo.bindCarousel($slider, $dots, !!effectiveOptions.autoplay, this.dataset.motionLabel, !!(saved && saved.paused));
            }
            const synchronizeSlides = () => {
              target.querySelectorAll('.slick-slide').forEach(slide => {
                const inactive = !slide.classList.contains('slick-active');
                slide.inert = inactive;
                slide.setAttribute('aria-hidden', String(inactive));
              });
            };
            // Slick runs its own ADA pass after afterChange. Reconcile once it finishes.
            const queueSlides = () => queueMicrotask(() => { if ($slider.hasClass('slick-initialized')) synchronizeSlides(); });
            $slider.on('beforeChange' + namespace + ' afterChange' + namespace + ' reInit' + namespace + ' setPosition' + namespace, queueSlides);
            synchronizeSlides();
            const reduce = event => { if (event.matches && $slider.hasClass('slick-initialized')) $slider.slick('slickPause'); };
            if (!$dots.length) motion.addEventListener('change', reduce);
            targetCleanups.push(() => {
              if ($slider.hasClass('slick-initialized')) this.savedStates.set(target, {slide:$slider.slick('slickCurrentSlide'), paused:target.hasAttribute('data-dio-motion-paused') ? target.getAttribute('data-dio-motion-paused') === 'true' : $slider.slick('getSlick').paused});
              if (motionCleanup) motionCleanup();
              motion.removeEventListener('change', reduce);
              $slider.off(namespace); $dots.find('button').off(namespace);
              target.querySelectorAll('.slick-slide').forEach(slide => { slide.inert = false; });
              if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
              $dots.empty();
            });

            }
            return () => targetCleanups.forEach(cleanup => cleanup());
          };
          const restoreFocusAfterMount = target => {
            const active = document.activeElement;
            const dots = this.dataset.dots && scope.querySelector(this.dataset.dots);
            let replacement;
            if (active === target.previousElementSibling && active.classList.contains('dio-motion-toggle')) replacement = () => target.previousElementSibling;
            else if (target.contains(active) && active.closest('.slick-prev')) replacement = () => target.querySelector('.slick-prev');
            else if (target.contains(active) && active.closest('.slick-next')) replacement = () => target.querySelector('.slick-next');
            else if (dots && dots.contains(active)) {
              const index = Array.from(dots.querySelectorAll('button')).indexOf(active);
              replacement = () => dots.querySelectorAll('button')[index];
            } else if (target.contains(active)) replacement = () => active.isConnected ? active : null;
            return replacement && (() => replacement()?.focus({preventScroll:true}));
          };
          const reconcile = () => {
            frame = null;
            if (cancelled || !this.isConnected || this.generation !== generation) return;
            // Read every presentation decision before any mount/destroy writes.
            const displays = new Map();
            const shown = new Map(targets.map(target => [target, presented(target, displays)]));
            const responsive = responsiveState();
            const focus = new Map();
            for (const [target, state] of mounted) {
              if (shown.get(target) && state.key !== responsive.key && responsive.options) focus.set(target, restoreFocusAfterMount(target));
            }
            for (const [target, state] of mounted) {
              if (!shown.get(target) || state.key !== responsive.key || !responsive.options) { state.cleanup(); mounted.delete(target); }
            }
            if (!responsive.options || !targets.some(target => shown.get(target))) return;
            const ready = kind === 'owl' ? $.fn.owlCarousel : $.fn.slick;
            if (!ready) {
              if (preparing) return;
              preparing = true;
              window.DioAssets.load(this.dataset.library, {dependencies:['jquery'], library:kind === 'owl' ? 'owlCarousel' : 'slick'})
                .then(() => { preparing = false; schedule(); }).catch(error => { preparing = false; console.error(error); });
              return;
            }
            targets.forEach(target => {
              if (!mounted.has(target) && shown.get(target)) {
                const cleanup = mount(target, responsive.options);
                if (cleanup) {
                  mounted.set(target, {cleanup, key:responsive.key});
                  focus.get(target)?.();
                }
              }
            });
          };
          const schedule = () => { if (!cancelled && frame === null) frame = requestAnimationFrame(reconcile); };
          // Watch only presentation ancestors, never animated slider children.
          const observer = new MutationObserver(schedule);
          const owners = new Set();
          targets.forEach(target => {
            for (let owner = target; owner; owner = owner.parentElement) {
              owners.add(owner); if (owner === scope) break;
            }
          });
          owners.forEach(owner => observer.observe(owner, {attributes:true, attributeFilter:['hidden','style','class','open']}));
          const width = window.matchMedia('(max-width: 749px)');
          width.addEventListener('change', schedule);
          if (media) media.addEventListener('change', schedule);
          if (managedResponsive) window.addEventListener('resize', schedule, {passive:true});
          cleanups.push(() => {
            cancelled = true; observer.disconnect();
            if (frame !== null) cancelAnimationFrame(frame);
            width.removeEventListener('change', schedule);
            if (media) media.removeEventListener('change', schedule);
            if (managedResponsive) window.removeEventListener('resize', schedule);
            mounted.forEach(state => state.cleanup()); mounted.clear();
          });
          reconcile();
        }
        this.cleanup = () => cleanups.forEach(cleanup => cleanup());
      } catch (error) { console.error(error); }
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      if (this.cleanup) this.cleanup();
      this.cleanup = undefined;
    }
  });
})();
